export default "__VITE_ASSET__DPEvwccg__"